// extracted by mini-css-extract-plugin
module.exports = {"listStyle":"U3SLAuilGlHlKeeTffRz5","taskIdStyle":"EXLPf9BDCD87c4O_-KSow","dialogContent":"_3Oc-pjap7k90lBEWl0VoNZ"};